import moment from 'moment'
import { NuxtCookies } from 'cookie-universal-nuxt'
import { Store } from 'vuex'
import { RootState } from '@/store'
import * as types from '@/store/order/types'
import OrderEntity, { IOrderProps } from '@/entities/Order'
import { IResponseProps } from '@/entities/Response'

export default class OrderRepository {
  private cookies: NuxtCookies
  private store: Store<RootState>

  constructor(cookies: NuxtCookies, store: Store<RootState>) {
    this.cookies = cookies
    this.store = store
  }

  set data(value: IResponseProps<IOrderProps>) {
    this.store.commit(new types.Store(value))
  }

  get data(): IResponseProps<IOrderProps> {
    return this.store.state.order.response
  }

  set current(value: IOrderProps | null) {
    this.store.commit(new types.Current(value))
  }

  get current(): IOrderProps | null {
    return this.store.state.order.current
  }

  get entity(): OrderEntity {
    return new OrderEntity(this.store.state.order.current)
  }

  set year(value: number) {
    this.store.commit(new types.Year(value))
  }

  get year(): number {
    return this.store.state.order.year || moment().year()
  }

  set method(value: string | null) {
    this.store.commit(new types.Method(value))
  }

  get method(): string | null {
    return this.store.state.order.method || this.store.state.user.current?.payments?.type || null
  }
}
